export default __webpack_public_path__ + "static/media/featured-item-12.68b12f28.png";